// extracted by mini-css-extract-plugin
module.exports = {"half-page-content":"HalfPageContentWithContainer_half-page-content__6ZKCX"};